import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ClientsService } from "../services/clients";
import { selectUserRoles } from "../../SharedModule/redux/reducers/auth.reducer";
import {
  IsClientsLoaded,
  IsClientsLoading,
  IsShowingClients,
  load,
  SelectClientsOwners,
  SelectFilterOwnersSelected,
  SelectFilterText,
  SelectNeedRefresh,
  SelectOrderedBy,
  setIsClientsLoading,
} from "../redux/reducers/clientsList.reducer";

export const useClients = () => {
  const dispatch = useDispatch();

  const { rolesLoaded, userRolesList } = useSelector(selectUserRoles);
  const isClientsLoading = useSelector(IsClientsLoading);
  const isClientsLoaded = useSelector(IsClientsLoaded);
  const { clientlist: clients } = useSelector(SelectOrderedBy);
  const isShowingClients = useSelector(IsShowingClients);
  const filterText = useSelector(SelectFilterText);
  const filterOwnersSelected = useSelector(SelectFilterOwnersSelected);
  const clientsOwners = useSelector(SelectClientsOwners);
  const needRefresh = useSelector(SelectNeedRefresh);

  const loadClients = useCallback(async () => {
    if (rolesLoaded && (!isClientsLoaded || (isClientsLoaded && needRefresh))) {
      dispatch(setIsClientsLoading(true));
      const clientsInfo = await ClientsService.getClients();
      dispatch(load(clientsInfo));
    }
  }, [dispatch, rolesLoaded, isClientsLoaded, needRefresh]);

  useEffect(() => {
    loadClients();
  }, [loadClients]);

  return {
    clients,
    clientsOwners,
    isClientsLoading,
    isShowingClients,
    filterText,
    filterOwnersSelected,
    rolesLoaded,
    userRolesList,
  };
};
